import React from 'react';
import {FontAwesomeIcon} from "@fortawesome/react-fontawesome";
import {Link} from 'react-router-dom';
import {faChevronLeft, faQuestionCircle} from "@fortawesome/free-solid-svg-icons";

import "./Header.css";

const Header = ({isWelcome, draftActiveProject: {title: draftActiveProjectTitle}, clsActive, handleToggle}) => {
  
  return (
    <div className="header">
      <div className="header-sidebar-toggle" onClick={handleToggle}>
        <FontAwesomeIcon
          className={`header-sidebar-toggle-icon ${clsActive}`}
          icon={faChevronLeft}
        />
      </div>
      <div className="container">
        <div className="row justify-content-center justify-content-md-start">
          <div className="col-12 col-md-10">
            <div className="header-text text-center text-md-left">Drawing dashboard</div>
            {
              // <div className="header-text text-center text-md-left d-md-none">&nbsp;{!isWelcome?draftActiveProjectTitle:"Drawing widget dashboard"}&nbsp;</div>
            }
          </div>
          {
            !isWelcome
            && (
              <div className="col-2 d-none d-md-block">
                <Link
                    to="/"
                    className="btn btn-link"
                >User guide</Link>
              </div>
            )
          }
          {
            !isWelcome
            && (
              <div className="d-md-none position-absolute" style={{right:0,top:0}}>
                <Link
                  className="btn btn-link"
                  to="/"
                >
                  User guide
                </Link>
              </div>
            )
          }
        </div>
      </div>
    </div>
  );
};

export default Header;
